































import Vue from 'vue'
import Compartments from './Compartments.vue'
import DxList from 'devextreme-vue/list'
import { mapActions } from 'vuex'

export default Vue.extend({
  components: { Compartments, DxList },
  props: ['entry'],
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions(['setFilter']),
    selectSubstrate(value: string) {
      this.setFilter({filter: ['Substrates_chebi_label','=',value]})
    },
    selectLocalization(value: string) {
      this.setFilter({filter: ['Subcellular_localization','=',value]})
    },
  }
})
